
class BeautyRoutineTabs {
  constructor(sectionId) {
    this.section = document.querySelector(`#shopify-section-${sectionId}`) || document.querySelector('.beauty-routine-section');
    if (!this.section) return;
    
    this.swipers = {};
    this.init();
  }

  init() {
    this.initSwiper();
    this.initTabs();
    this.initProductInteractions();
  }

  initSwiper() {
  }

  initTabs() {
    const tabs = this.section.querySelectorAll('.beauty-routine-tab');
    const contents = this.section.querySelectorAll('.beauty-routine-tab-content');

    tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const tabIndex = tab.getAttribute('data-tab');
        
        // Remove active class from all tabs and contents
        tabs.forEach(t => t.classList.remove('active'));
        contents.forEach(c => c.classList.remove('active'));
        
        // Add active class to clicked tab and corresponding content
        tab.classList.add('active');
        const targetContent = this.section.querySelector(`[data-content="${tabIndex}"]`);
        if (targetContent) {
          targetContent.classList.add('active');
        }

        // Update swiper layout if needed
        setTimeout(() => {
          const swiper = targetContent?.querySelector('.swiper');
          if (swiper && swiper.swiper) {
            swiper.swiper.update();
          }
        }, 100);
      });
    });
  }

  initProductInteractions() {
  }
}

document.addEventListener('DOMContentLoaded', () => {
  // Initialize for all beauty routine sections
  const beautyRoutineSections = document.querySelectorAll('.beauty-routine-section');
  beautyRoutineSections.forEach((section, index) => {
    new BeautyRoutineTabs(`beauty-routine-tabs-${index}`);
  });
});

// Export for module usage if needed
if (typeof module !== 'undefined' && module.exports) {
  module.exports = BeautyRoutineTabs;
}